import GlobalStyles from "@mui/material/GlobalStyles"

export const GlobalStyle = () => (
    <GlobalStyles
        styles={{
            "html, body, #root": {
                width: "100%",
                height: "100%",
                fontFamily: "Noto Sans CJK TC, sans-serif",
                userSelect: "none",
            },
            ul: {
                paddingInlineStart: 0,
            },
            li: {
                listStyle: "none",
            },
            "#root": {
                display: "flex",
            },
            ".StripeElement": {
                height: "20px",
                padding: "12px 15px",
                boxSizing: "content-box",
                backgroundColor: "white",
                "& input": {
                    fontSize: "16px",
                },
            },
        }}
    />
)
